module.exports = __webpack_public_path__ + "img/l-hd.16c1ec7d.webp";